import React from 'react';
import { BrowserRouter , Route, Routes } from 'react-router-dom';
import LoginPage from '../pages/Login/Login';
import Dashboard from '../pages/Dashboard/Dashboard';
import TaskPage from '../pages/Task/Task';
import EmployeePage from '../pages/EmployeeListing/EmployeeListing';
import ActivityPage from '../pages/Activity/Activity';
import DocumentsPage from '../pages/Documents/Documents';
import EmployeeReport from '../pages/EmployeeReport/EmployeeReport';


const AppRoutes = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/task" element={<TaskPage />} />
        <Route path="/employee-listing" element={<EmployeePage />} />
        <Route path="/employee-activity" element={<ActivityPage />} />
        <Route path="/documents" element={<DocumentsPage />} />
        <Route path="/employee-report" element={<EmployeeReport />} />
      </Routes>
    </BrowserRouter>
  );
}

export default AppRoutes;
